var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5944 27.7191L27.6032 27.7117L27.6113 27.7036C28.0288 27.2846 28.2504 26.7816 28.25 26.2648C28.2496 25.7479 28.0272 25.2449 27.6082 24.826L20.7088 17.8988C21.9229 16.1241 22.6481 13.9939 22.6481 11.7364C22.6481 5.66278 17.7543 0.75 11.7004 0.75C5.64375 0.75 0.75 5.66278 0.75 11.7392C0.75 17.8128 5.64375 22.7256 11.6977 22.7256C13.9443 22.7256 16.0692 21.998 17.8376 20.7799L24.739 27.7036C25.4728 28.4401 26.7564 28.419 27.5944 27.7191ZM11.6977 19.6984C7.3046 19.6984 3.76531 16.1476 3.76531 11.7364C3.76531 7.32524 7.3046 3.77442 11.6977 3.77442C16.0907 3.77442 19.63 7.32524 19.63 11.7364C19.63 16.1476 16.0907 19.6984 11.6977 19.6984Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.9cde8576e6d23ccf5ebfe3dae50d38b6.svg";
export { ForwardRef as ReactComponent };